import type React from "react";
import { useTranslation } from "react-i18next";
import { FaTriangleExclamation, FaMicrophoneSlash } from "react-icons/fa6";
import { Button, Modal } from "@eriol-io/design-system";

export interface AudioConfirmModalProps {
  isOpen: boolean;
  availableMicrophones: Array<{ name: string; deviceInfo: MediaDeviceInfo }>;
  onContinueWithoutAudio: () => void;
  onClose: () => void;
}

const AudioConfirmModal: React.FC<AudioConfirmModalProps> = ({
  isOpen,
  availableMicrophones: _availableMicrophones,
  onContinueWithoutAudio,
  onClose,
}) => {
  const { t } = useTranslation("permissions");

  const footer = (
    <div className="flex justify-end gap-3">
      <Button
        variant="secondary"
        onClick={onContinueWithoutAudio}
        className="bg-red-700 text-white border-red-600 hover:bg-red-600 hover:border-red-500"
      >
        <FaMicrophoneSlash size={14} />
        {t("AUDIO_CONFIRM_MODAL.actions.continueWithoutAudio")}
      </Button>
    </div>
  );

  return (
    <Modal
      isOpen={isOpen}
      title={t("AUDIO_CONFIRM_MODAL.title")}
      onClose={onClose}
      showCloseButton={true}
      footer={footer}
    >
      <div className="flex flex-col items-center justify-center text-center gap-3">
        <div className="text-yellow-400">
          <FaTriangleExclamation size={48} />
        </div>

        <div>
          <p className="text-yellow-100 font-semibold text-lg">
            {t("AUDIO_CONFIRM_MODAL.warning.title")}
          </p>
          <p className="text-yellow-200 text-sm mt-1">{t("AUDIO_CONFIRM_MODAL.warning.message")}</p>
        </div>
      </div>
    </Modal>
  );
};

export default AudioConfirmModal;
